//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "CaroSort",
	props: {
		sort: Object,
		setSort: Function,
		results: Object,
	},
	data() {
		return {
		};
	},
	computed: {
		sortModel: {
			get() {
				// honestly not sure why this is necessary...
				if(!this.sort) {
					return this.results.sortOptions[0].fieldName
				} else {
					return this.sort.fieldName;
				}
			},
			set(val) {
				const item = this.results.sortOptions.find(o => o.fieldName === val);
				this.setSort(item);
			},
		},
	},
	created() {
	}
};
